export default "__VITE_ASSET__BI7Hxcuv__"